export default __webpack_public_path__ + "static/media/appIcon.b71cd35f.svg";